import {Component, OnInit, OnDestroy} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {AuthService} from './auth/auth.service';
import {TITLE_CONFIG} from './config/title-config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  // @HostListener('window:beforeunload', ['$event'])
  // unloadHandler(event:Event) {
  //   event
  //   localStorage.removeItem('token');
  //   localStorage.removeItem('user.role');
  //   localStorage.removeItem('username');
  //   localStorage.removeItem('userID');
  //   localStorage.removeItem('isAdmin');
  //   localStorage.removeItem('drm_token');
  //   localStorage.removeItem('urls');
  //   // ...
  // }
  // @HostListener('window:load', ['$event'])
  // unloadHandler(event: Event) {
  //   event;
  //   this.utility.headerSetter();
  // }
  title = 'app';

  constructor(private authserv: AuthService, private titleService: Title, private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.updateTitleOnNavigation();
    this.closeOpenModalsOnNavigation();
  }

  ngOnDestroy() {
    this.authserv.keepAliveExit();
  }

  /**
   * Bootstrap (jQuery) modals append their `.modal-backdrop` element and lock
   * the page via the `modal-open` body class outside Angular's component tree.
   * When the browser back/forward button navigates away while a modal is open,
   * Angular destroys the component but the backdrop and body scroll-lock are left
   * behind — the page stays dark and unclickable. Clean them up on navigation.
   */
  private closeOpenModalsOnNavigation() {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      const openModals = document.querySelectorAll('.modal.show, .modal.in');
      if (!openModals.length && !document.body.classList.contains('modal-open')) {
        return;
      }

      openModals.forEach((modal) => {
        modal.classList.remove('show', 'in');
        modal.setAttribute('aria-hidden', 'true');
        (modal as HTMLElement).style.display = 'none';
      });

      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.parentNode && backdrop.parentNode.removeChild(backdrop));

      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    });
  }

  private updateTitleOnNavigation() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          const currentUrl = this.router.url;
          const langConfig = TITLE_CONFIG['en'];
          let foundTitle = '';

          Object.keys(langConfig).forEach((key) => {
            if (currentUrl.includes(key)) {
              foundTitle = langConfig[key];
            }
          });

          return foundTitle ? `ATLAS CMS | ${foundTitle}` : 'ATLAS CMS';
        }),
      )
      .subscribe((title) => {
        this.titleService.setTitle(title);
      });
  }
}
